import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useKanbanAppointmentCardStyles = makeStyles((_theme: Theme) =>
    createStyles({
        root: {
            boxSizing: 'border-box',
            width: 341,
            height: 120,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            borderRadius: 10,
            position: 'relative',
            padding: 12,
            backgroundColor: '#fff',
            border: 'solid 1px #D4D4D4',
            cursor: 'pointer',
            textAlign: 'left',
            overflow: 'hidden',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        grabbable: {
            cursor: 'grab'
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minHeight: 26
        },
        checkbox: {
            flexShrink: 0,
            height: 26,
            display: 'flex',
            alignItems: 'center'
        },
        checkboxDisabled: {
            color: '#c4c4c4',
            cursor: 'default',
            pointerEvents: 'none'
        },
        body: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            minWidth: 0,
            minHeight: 0
        },
        avatar: {
            width: 44,
            height: 44,
            flexShrink: 0
        },
        details: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 4,
            minWidth: 0,
            flex: 1
        },
        nameRow: {
            flex: 1,
            minWidth: 0,
            height: 26,
            display: 'flex',
            alignItems: 'center',
            gap: 4
        },
        name: {
            minWidth: 0,
            margin: 0,
            padding: '0 0 2px',
            overflow: 'hidden',
            border: 0,
            background: 'transparent',
            color: '#000',
            fontFamily: 'Poppins, sans-serif',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '20px',
            textAlign: 'left',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            cursor: 'pointer'
        },
        heart: {
            flexShrink: 0,
            width: 16,
            height: 16,
            color: '#EF4F57',
            fontSize: 16
        },
        meta: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            minWidth: 0,
            color: '#000',
            fontFamily: 'Poppins, sans-serif',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '100%',
            marginTop: 4
        },
        metaItem: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 0
        },
        metaWeight: {
            flexShrink: 0
        },
        metaIcon: {
            flexShrink: 0,
            width: 16,
            height: 16,
            fontSize: 14,
            color: '#000'
        },
        metaText: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        schedule: {
            margin: 0,
            overflow: 'hidden',
            color: '#7A7A7A',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Poppins, sans-serif',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '100%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        location: {
            'display': 'flex',
            'alignItems': 'center',
            'flexShrink': 0,
            'gap': 6,
            'minWidth': 0,
            'margin': 0,
            'color': '#7A7A7A',
            'fontFeatureSettings': "'liga' off, 'clig' off",
            'fontFamily': 'Poppins, sans-serif',
            'fontSize': 14,
            'fontStyle': 'normal',
            'fontWeight': 400,
            'lineHeight': '18px',

            '& span': {
                overflow: 'hidden',
                color: '#7A7A7A',
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: 'Poppins, sans-serif',
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '18px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        },
        status: {
            flexShrink: 0,
            marginLeft: 'auto',
            width: 'auto'
        },
        statusButton: {
            'width': 'auto',
            'height': 'auto',

            '& > div:first-child': {
                boxSizing: 'border-box',
                width: 'max-content',
                height: 26,
                minHeight: 26,
                padding: '0 8px'
            },

            '& > div:first-child p': {
                width: 'auto',
                overflow: 'visible',
                fontSize: 13,
                lineHeight: '100%',
                whiteSpace: 'nowrap'
            }
        },
        title: {
            gap: 4,
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 1,
            color: '#000',
            display: 'flex',
            alignItems: 'center'
        },
        medicalConditionIcon: {
            color: '#EF4F57'
        },
        content: {
            gap: 6,
            flex: 1,
            display: 'flex',
            padding: '4px 0px',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        tags: {
            gap: 12,
            display: 'flex',
            flexWrap: 'wrap'
        },
        tag: {
            'gap': 4,
            'fontSize': 14,
            'fontWeight': 400,
            'lineHeight': 1,
            'display': 'inline-flex',
            'alignItems': 'center',
            'color': '#000',

            '& > svg': {
                fontSize: '1.2em'
            }
        },
        description: {
            margin: 0,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1,
            color: '#7A7A7A',
            display: 'block'
        }
    })
);
